export default __webpack_public_path__ + "static/media/marc13.e2d79fe2.jpg";